module.exports = __webpack_public_path__ + "media/images/social-media/instagram-6fcf3886751fb89cf481ae20e31fc7b2.svg";